import { Skeleton } from "@/components/ui/skeleton";

export function TicketHistorySkeleton() {
  return (
    <div className="flex items-start gap-3 px-4 py-3.5">
      <Skeleton className="size-6 rounded-full shrink-0" />
      <div className="flex flex-1 flex-col gap-2">
        <Skeleton className="h-3.5 w-3/4" />
        <Skeleton className="h-2.5 w-16" />
      </div>
    </div>
  );
}
